import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiNewspaper, FiExternalLink, FiCalendar, FiSearch } = FiIcons;

const StoriesSection = ({ stories }) => {
  if (!stories || stories.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
      >
        <div className="flex items-center space-x-3 mb-6">
          <SafeIcon icon={FiNewspaper} className="text-2xl text-purple-400" />
          <h3 className="text-2xl font-bold text-white">📰 TOP RESULTS</h3>
        </div>
        
        <div className="text-center py-8">
          <SafeIcon icon={FiSearch} className="text-4xl text-blue-400 mx-auto mb-4" />
          <p className="text-purple-300">
            No search results found for this person. This could mean:
          </p>
          <ul className="text-purple-400 text-sm mt-4 space-y-2 text-left max-w-md mx-auto">
            <li>• The person has minimal online presence</li>
            <li>• Search API credentials may be invalid</li>
            <li>• Privacy settings restrict search visibility</li>
            <li>• Person name may be misspelled or uncommon</li>
          </ul>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={FiNewspaper} className="text-2xl text-purple-400" />
        <h3 className="text-2xl font-bold text-white">📰 TOP RESULTS</h3>
        <span className="text-purple-300 text-sm ml-auto">
          {stories.length} result{stories.length !== 1 ? 's' : ''} found
        </span>
      </div>

      <div className="space-y-4">
        {stories.map((story, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-black/30 rounded-lg p-6 border border-purple-500/20 hover:border-purple-400/40 transition-colors duration-300"
          >
            <div className="flex items-start justify-between mb-3">
              <h4 className="text-lg font-semibold text-white flex-1 pr-4">
                {story.title}
              </h4>
              <SafeIcon icon={FiExternalLink} className="text-purple-400 flex-shrink-0" />
            </div>
            <p className="text-purple-300 mb-3">{story.summary}</p>
            <div className="flex items-center justify-between text-sm">
              <a 
                href={story.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-400 hover:text-blue-300 truncate flex-1 mr-4"
              >
                {story.url}
              </a>
              <div className="flex items-center space-x-2 text-purple-400 flex-shrink-0">
                <SafeIcon icon={FiCalendar} className="text-sm" />
                <span>{story.date}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default StoriesSection;